/*
*
* Version : 1.0.0
* 04/09/2016 - 10h18
*
*! Octave Web7 !*/

(function () {
  'use strict';

  angular
    .module('directive.truncate', [])

    /* @ngInject */
    .directive('truncate', function () {
      return {
        scope: {
          maxHeight: '<',
          ellipsis: '@?'
        },
        restrict: 'A',
        link: function (scope, element, attrs) {
          if (window.isBot) return;

          if (attrs.truncate === 'true') {
            var api;
            var init = function () {
              setTimeout(function () {
                api = element.dotdotdot({
                  height: scope.maxHeight,
                  watch: 'window',
                  ellipsis: angular.isDefined(scope.ellipsis) ? scope.ellipsis : '\u2026 ',
                  keep: 'a.readmore, a.readless',
                  callback: function (isTruncated) {
                    $(this).addClass('active')
                      .toggleClass('ddd-not-truncated', !isTruncated)
                      .find('.readmore').off().click(function (e) {
                        e.preventDefault();
                        element.removeClass('active').addClass('ddd-more');
                        api.destroy();
                        element.find('.readless').off().click(function (ev) {
                          ev.preventDefault();
                          init();
                        });
                      });
                    setTimeout(function () {
                      $(window).trigger('resize');
                    });
                  }
                }).data('dotdotdot');
              });
            };

            angular.element(document).ready(init);

          }
        }
      };
    });

})();
